// extracted by mini-css-extract-plugin
export var cmsContent = "post-content-module--cmsContent--LXP6z";
export var heading = "post-content-module--heading--03nd7";
export var intro = "post-content-module--intro--x6jMk";
export var sectionContent = "post-content-module--section-content--d2cdG";
export var tag = "post-content-module--tag--mVN44";
export var tagContent = "post-content-module--tagContent--PN42i";
export var tagsContent = "post-content-module--tagsContent--dUfwE";